import { RadioGroup } from '@app/components/various/Fields/RadioGroup';
import { Filter } from '@typings';

interface Props {
  filterField: string;
  fieldOptions: Filter.Option<string>[];
  selectedOption: string | undefined;
  onSelectedValueChange: (selectedValue: string) => void;
}

export const FiltersRadioGroup = ({ filterField, fieldOptions, selectedOption, onSelectedValueChange }: Props) => {
  const options = fieldOptions.map(({ data, filterValue }) => ({
    name: data,
    value: filterValue,
  }));

  const handleSetRadioFilter = (value: string) => {
    onSelectedValueChange(value);
  };

  const initialValue = options[0]?.value ?? '';

  return <RadioGroup name={filterField} value={selectedOption ?? initialValue} options={options} onChange={handleSetRadioFilter} />;
};
